import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import type {
  CreatePublicLeadRequest,
  PublicLeadApiConfig,
} from './public-lead-api.interface';

@Injectable({ providedIn: 'root' })
export class PublicLeadApiService {
  readonly #http = inject(HttpClient);
  readonly #isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  private apiUrl = '';

  public configure(config: PublicLeadApiConfig): void {
    this.apiUrl = config.apiUrl;
  }

  /** `POST /public/leads` — optional `Authorization` via interceptors. */
  public submit(body: CreatePublicLeadRequest): Observable<void> {
    if (!this.#isBrowser) {
      return of(undefined);
    }

    return this.#http
      .post(`${this.apiUrl}/public/leads`, body, { observe: 'response' })
      .pipe(map(() => undefined));
  }
}
